"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WfsBboxRequestParamsBase = void 0;
var WfsBboxRequestParamsBase = /** @class */ (function () {
    function WfsBboxRequestParamsBase(bboxParameterName, formatString) {
        this.bboxParameterName = bboxParameterName;
        this.formatString = formatString;
        this.replaceTokens = function (s, data) {
            for (var attributeName in data) {
                if (data.hasOwnProperty(attributeName)) {
                    s = s.replace(new RegExp("\\[" + attributeName + "\\]", "g"), data[attributeName]);
                }
            }
            return s;
        };
    }
    WfsBboxRequestParamsBase.prototype.getBboxUrlParameter = function (bbox) {
        var bounds = {
            minx: bbox[0],
            miny: bbox[1],
            maxx: bbox[2],
            maxy: bbox[3]
        };
        var bboxString = this.replaceTokens(this.formatString, bounds);
        var urlString = this.bboxParameterName + "=" + bboxString;
        return urlString;
    };
    return WfsBboxRequestParamsBase;
}());
exports.WfsBboxRequestParamsBase = WfsBboxRequestParamsBase;
//# sourceMappingURL=WfsBboxRequestParamsBase.js.map